import { Box, Typography } from "@mui/material";
import { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useDimensions, usePayment } from "../hooks";
import { PaymentMethod } from "../models/payment";
import { CorporateService } from "../models/Service";
import BoxBillPayment from "../shared/boxBillPayment";
import CustomInput from "./inputs/cutsomInput";
import PaymentMethods from "./paymentMethods";
import PhoneNumberInputs from "./phoneNumberInput";
import { useQueryPaymentMethods } from "../api/queries";
import { getStorageToken } from "../utils";
import ServiceChargeSummary from "./ServiceChargeSummary";

const PaymentForSearch = ({
  service,
  payments,
}: {
  service: CorporateService;
  payments: PaymentMethod[];
}) => {
  const token = getStorageToken();
  const { isSmall } = useDimensions();
  const { currentStep, amount } = usePayment();
  const { t } = useTranslation();
  const { control, watch } = useFormContext();
  const { setAmount } = usePayment();

  const paymentMethods = useQueryPaymentMethods({
    corporateId: String(service?.corporate_subsidiary_id!),
    enabled: !!token,
    authorisation: token || "",
  });

  const amountValue = watch("customerAmount");

  useEffect(() => {
    if (amountValue !== undefined) {
      const parsed = parseFloat(amountValue);
      if (!isNaN(parsed)) {
        setAmount(`${parsed}`);
      } else {
        setAmount("");
      }
    }
  }, [amountValue, setAmount]);

  return (
    <Box>
      <Box
        display={isSmall || currentStep === 3 ? "block" : "flex"}
        justifyContent={"space-between"}
        alignItems="flex-start"
        paddingX={isSmall ? 2 : 10}
      >
        <BoxBillPayment service={service} />
        {currentStep === 3 && <ServiceChargeSummary />}

        {currentStep === 2 && (
          <Box
            sx={{
              width: isSmall ? "unset" : "40%",
            }}
          >
            <Typography variant="h6" fontWeight="bold" mb={2}>
              {t("payment.paymentForSearch.step1_title")}
            </Typography>
            <Box>
              <CustomInput
                id={"account_number-id"}
                control={control}
                name="customerAmount"
                sx={[{ width: "100%", borderColor: "red", color: "red" }]}
                variant="outlined"
                label={t("payment.paymentForSearch.amount_label")}
                defaultValue={amount}
                rules={{
                  required: t("errors.field_required"),
                }}
                placeholder={t("payment.paymentForSearch.amount_placeholder")}
              />
              <Typography sx={{ fontSize: 11 }}>
                {t("payment.paymentForSearch.amount_hint")}
              </Typography>
            </Box>

            <PaymentMethods
              payments={paymentMethods?.data as PaymentMethod[]}
            />
            <PhoneNumberInputs service={service} isVertical />
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default PaymentForSearch;
